module.exports = __webpack_public_path__ + "static/media/clock.1ecd8aa0.svg";